
import Visual1 from "../../../img/screenshots/influencers/influencer-feature-01.png";
import Visual2 from "../../../img/screenshots/influencers/influencer-feature-02.png";
import Visual3 from "../../../img/screenshots/influencers/influencer-feature-03.png";
import Visual4 from "../../../img/screenshots/influencers/influencer-feature-04.png";



export const InfluencerFeaturesContent = [
    { 
      title:"Share destination tips and recommendations easily",     
      subtitle:"Cluster your tips per location and per category",      
      text:"Group your recommendations for a specific destination. From restaurants to bars and hotels you can save your tips and share them using one link per destination.",
      image:Visual1
    },
    { 
      title:"Increase your following base",     
      subtitle:"Widen your area of influence",      
      text:"Increase your reach by having a multi-channel approach. Use Stippl to group your travels, tips and recommendations as you engage with a wider audience.",
      image:Visual2
    },
    { 
      title:"Upscale your business model",     
      subtitle:"Stippl can be your platform",      
      text:"Start building partnerships that you can then use through Stippl to increase income. It’s just a matter of putting your affiliate links in your profile and let your followers book their experiences through them.",
      image:Visual3
    },
    { 
      title:"Boost reputation as a trusted travel resource",     
      subtitle:"Be the to-go-to for travel inspiration",      
      text:"As an influencer, it can be difficult to be considered as trusted travel resource. By providing valuable and actionable content, you’ll be contributing directly to your followers’ experiences.",
      image:Visual4
    }
  ]